const common = {
  Test: 'Test',
  Save: 'บันทึก',
};

export default common;
